import { render, staticRenderFns } from "./project_down.vue?vue&type=template&id=9d4468ce&scoped=true&"
import script from "./project_down.vue?vue&type=script&lang=js&"
export * from "./project_down.vue?vue&type=script&lang=js&"
import style0 from "./project_down.vue?vue&type=style&index=0&id=9d4468ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4468ce",
  null
  
)

export default component.exports